import type { IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { IconButton as MuiIconButton } from '@mui/material';

export type FlatIconButtonProps = MuiIconButtonProps;

/** Transparent icon button. Based on MUI IconButton https://mui.com/material-ui/api/icon-button/ */
export const FlatIconButton = ({ children, ...props }: FlatIconButtonProps) => (
  <MuiIconButton {...props}>{children}</MuiIconButton>
);
